// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1hhBB","detailsBorder":"styles_detailsBorder__3GsHa"};